import { ValueType } from 'react-native-dropdown-picker';
import { CheckBoxInputFormProps } from '@/components/Form/types';
import React, { useEffect, useState } from 'react';
import { RadioButton, Text, useTheme } from 'react-native-paper';
import { Pressable, View, StyleSheet } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { Color } from '@/GlobalStyles';
import { useTranslation } from 'react-i18next';
import HelpButton from '@/components/HelpButton';

const CheckBoxInput = React.forwardRef(
  <T extends ValueType>(
    props: CheckBoxInputFormProps,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref
  ): React.ReactElement => {
    const {
      defaultValue,
      onChangeValue,
      error,
      containerStyle,
      label,
      asRadio = false,
      canUncheckRadio = false,
      disabled = false,
      withHelpButton = false,
      helpFieldName,
      name,
      ...rest
    } = props;
    const theme = useTheme();

    const [value, setValue] = useState<number | undefined | null>(
      rest.value !== undefined ? rest.value : defaultValue || 0
    );

    const { t } = useTranslation();

    useEffect(() => {
      setValue(rest.value !== undefined ? rest.value : defaultValue || 0);
    }, [rest.value, defaultValue]);

    return (
      <View
        style={[
          {
            flexDirection: 'column',
            alignSelf: 'flex-start',
          },
          containerStyle,
        ]}
      >
        <Pressable
          style={styles.checkboxContainer}
          disabled={disabled}
          onPress={() => {
            if (asRadio && value === 1) {
              return;
            }
            const val = Math.abs((value || 0) - 1);
            setValue(val);
            onChangeValue && onChangeValue(val);
          }}
        >
          <View
            style={{
              backgroundColor: Color.BlancCasse,
              width: 18,
              height: 18,
              borderRadius: 9,
              left: 8,
              position: 'absolute',
            }}
          ></View>
          {asRadio ? (
            <RadioButton.Android
              status={value === 1 ? 'checked' : 'unchecked'}
              uncheckedColor={Color.colorGray_100}
              background={Color.BlancCasse}
              width={18}
              value={1}
              onPress={() => {
                if (value === 1 && !canUncheckRadio) {
                  return;
                }
                const val = Math.abs((value || 0) - 1);
                setValue(val);
                onChangeValue && onChangeValue(val);
              }}
            />
          ) : (
            <Checkbox.Android
              status={value === 1 ? 'checked' : 'unchecked'}
              uncheckedColor={Color.colorGray_100}
              background={Color.BlancCasse}
              width={18}
            />
          )}
          <Text variant={'bodyLarge'} style={[disabled ? { color: Color.colorGray_150 } : {}]}>
            {t(label)}
          </Text>
          {withHelpButton && (helpFieldName || name) && (
            <HelpButton
              fieldName={helpFieldName || name || ''}
              size={16}
              style={{ marginLeft: 4 }}
            />
          )}
        </Pressable>
        {error?.message ? (
          <Text
            variant={'labelMedium'}
            style={{
              color: theme.colors.error,
              marginLeft: 18,
              bottom: -18,
              flex: 1,
              position: 'absolute',
            }}
          >
            {props.error?.message}
          </Text>
        ) : null}
      </View>
    );
  }
);

export default CheckBoxInput;

const styles = StyleSheet.create({
  checkboxContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    columnGap: 8,
  },
});
